module.exports = __webpack_public_path__ + "img/estonia.6c2e4d71.svg";